import React, { useState } from 'react';
import MuiTab from '@material-ui/core/Tab';
import { TabPanel as MuiTabPanel, TabList as MuiTabList, TabContext as MuiTabContext } from '@material-ui/lab';
import MuiBox from '@material-ui/core/Box';
import MuiButton from '@material-ui/core/Button';
import MuiMenuItem from '@material-ui/core/MenuItem';
import AddTransactionModal from './AddTransactionModal';
import MuiSelect from '@material-ui/core/Select';
import MuiTextField from '@material-ui/core/TextField';
import MuiAddIcon from '@material-ui/icons/Add';

import TrackSplits from './TrackSplits';
import TransactionHistory from './TransactionHistory';

const operators = ['', '<', '>', '<=', '>=', '='];

export default function MainContent({
  account,
  refetch,
  ledgers,
  hasNextLedgerRowPage,
  hasPreviousLedgerRowPage,
  adjustLedgerPage,
  filterOperator,
  filterNumber,
  onFilterChange,
}) {
  const [onPanel, setOnPanel] = useState('1');
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <MuiTabContext value={onPanel}>
      <MuiBox>
        <MuiTabList onChange={(_evt, value) => setOnPanel(value)}>
          <MuiTab label="Transaction history" value="1" />
          <MuiTab label="Track/Splits" value="2" />
        </MuiTabList>
      </MuiBox>
      <MuiTabPanel value="1">
        <div style={{ display: 'flex', columnGap: '1rem', alignItems: 'center' }}>
          <MuiButton variant="contained" size="small" startIcon={<MuiAddIcon />} onClick={() => setIsDialogOpen(true)}>
            Add Transaction
          </MuiButton>
          <AddTransactionModal
            open={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
            onCreated={async () => {
              await refetch();
              setIsDialogOpen(false);
            }}
            recoup_account_id={account.recoup_account_id}
          />
          <div>Amount Filter</div>
          <MuiSelect name={'amountOperator'} onChange={onFilterChange} value={filterOperator}>
            {operators.map(operator => (
              <MuiMenuItem key={operator} value={operator}>
                {operator}
              </MuiMenuItem>
            ))}
          </MuiSelect>
          <MuiTextField name={'amountFilter'} type="number" onChange={onFilterChange} value={filterNumber} />
        </div>
        <div style={{ maxHeight: '25rem', overflow: 'auto', marginTop: '1rem' }}>
          <TransactionHistory ledgers={ledgers} refetch={refetch} />
        </div>
        <div style={{ display: 'flex', columnGap: '1rem' }}>
          <MuiButton
            disabled={!hasPreviousLedgerRowPage}
            variant="contained"
            size="small"
            onClick={() => adjustLedgerPage(-1)}>
            Previous Page
          </MuiButton>
          <MuiButton
            disabled={!hasNextLedgerRowPage}
            variant="contained"
            size="small"
            onClick={() => adjustLedgerPage(1)}>
            Next Page
          </MuiButton>
        </div>
      </MuiTabPanel>
      <MuiTabPanel value="2">
        <TrackSplits accountTracks={account.accountTracks} />
      </MuiTabPanel>
    </MuiTabContext>
  );
}
